module.exports = __webpack_public_path__ + "img/pr-3.96922915.png";